module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0121.jpg?v=beab8b4f";